import { render, staticRenderFns } from "./warehouse-base-info.vue?vue&type=template&id=f95f2702&"
import script from "./warehouse-base-info.vue?vue&type=script&lang=js&"
export * from "./warehouse-base-info.vue?vue&type=script&lang=js&"
import style0 from "./warehouse-base-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports